import type IntegrationType from "../objects/IntegrationType";

export interface LinkableIntegration {
  integrationType: IntegrationType;
  integrationUuid: string;
}

export const INTEGRATIONS_LIST_PATH = "/in";

export const INTEGRATION_DETAIL_VIEW_PATH: string =
  "/in/:integrationType/:integrationUuid";

export function getIntegrationDetailViewPath(
  linkableIntegration: LinkableIntegration,
) {
  return INTEGRATION_DETAIL_VIEW_PATH.replace(
    ":integrationUuid",
    linkableIntegration.integrationUuid,
  ).replace(":integrationType", linkableIntegration.integrationType);
}

export const INTEGRATION_EDIT_VIEW_PATH: string =
  "/in/:integrationType/:integrationUuid/edit";

export function getEditIntegrationViewPath(
  linkableIntegration: LinkableIntegration,
) {
  return INTEGRATION_EDIT_VIEW_PATH.replace(
    ":integrationUuid",
    linkableIntegration.integrationUuid,
  ).replace(":integrationType", linkableIntegration.integrationType);
}

export const INTEGRATION_CREATE_VIEW_PATH = "/in/create";
